import React from 'react'
import { StatusBannerTypes } from './status-banner.types'
import { WrapperStatusBanner } from './status-banner.styles'

function StatusBanner({ status }: StatusBannerTypes) {
	return <WrapperStatusBanner status={status}>{status}</WrapperStatusBanner>
}

export default StatusBanner
